import { BarChart3, FileText, Home, Settings, Shield } from "lucide-react";
import type { ReactNode } from "react";
import type { User } from "../types/models";
import { canAccessAdmin } from "../lib/permissions";

export type NavigationItem = {
  path: string;
  labelKey: string;
  icon: ReactNode;
};

export function getNavigationItems(user: User | null): NavigationItem[] {
  const items: NavigationItem[] = [
    { path: "/today", labelKey: "nav.today", icon: <Home size={20} aria-hidden="true" /> },
    { path: "/analytics", labelKey: "nav.analytics", icon: <BarChart3 size={20} aria-hidden="true" /> },
    { path: "/reports", labelKey: "nav.reports", icon: <FileText size={20} aria-hidden="true" /> },
    { path: "/settings", labelKey: "nav.settings", icon: <Settings size={20} aria-hidden="true" /> }
  ];
  if (canAccessAdmin(user)) {
    items.push({ path: "/admin", labelKey: "nav.admin", icon: <Shield size={20} aria-hidden="true" /> });
  }
  return items;
}
